import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserRequestsService } from 'src/app/services/user/user-requests.service';
import { UserStoreService } from 'src/app/services/user/user-store.service';

@Component({
  selector: 'app-modal-cucs',
  templateUrl: './modal-cucs.component.html',
  styleUrls: ['./modal-cucs.component.scss'],
})
export class ModalCucsComponent implements OnInit {
  results = [];
  filterInput = new UntypedFormControl();
  //
  constructor(
    public userStore: UserStoreService,
    private userRequests: UserRequestsService,
    public dialogRef: MatDialogRef<ModalCucsComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    this.results = this.userStore.userCUC;
    this.filterInput.valueChanges.subscribe((i) => this.fillResults(i));
  }

  fillResults(i) {
    this.results = this.userStore.userCUC.filter((c) => this.userStore.activeCUC.cuc !== c.cuc && c.cuc.indexOf(i) !== -1);
  }

  selectCUC(CUC) {
    this.userRequests.changeCUC(CUC);
  }

  doFilter() {}
}
